module.exports = __webpack_public_path__ + "static/img/product03-3.aa9f339a.png";